import {Button} from '@material-ui/core';
import {Help} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';

import HelpDialog from '../../auth/helpDialog';

const HelpSection: React.FC = () => {
  const {t} = useTranslation();
  const [open, setOpen] = React.useState(false);

  const openHelpDialog = () => {
    setOpen(true);
  };

  const closeHelpDialog = () => {
    setOpen(false);
  };
  return (
    <>
      <Button
        className={`full-width `}
        type="button"
        color="primary"
        onClick={openHelpDialog}
        startIcon={<Help />}
      >
        {t('secao-ajuda.pedir-ajuda')}
      </Button>

      <HelpDialog open={open} onClose={closeHelpDialog} />
    </>
  );
};

export default HelpSection;



// WEBPACK FOOTER //
// ./src/features/election/components/HelpSection.tsx